import React, { useState, useEffect } from "react";
import axios from "axios";
import "../Page.css";
import "./style.css";
import { Url, formatTimestamp } from "../../Services/Api";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import couponicon from "../../Assets/couponicon.png";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import Dropdowncustom from "../../Components/UI-Controls/Dropdown/dropdownaddgeneral1";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import csv from "../../Assets/csv.png"
import CustomBtnLogo from "../../Components/UI-Controls/Buttons/BtnLogo";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";


const { RangePicker } = DatePicker;

const Coupons = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filterLoading, setFilterLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [selectedPrize, setSelectedPrize] = useState("");
  const [dateRange, setDateRange] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [filtersApplied, setFiltersApplied] = useState(false);

  const [insights, setInsights] = useState({
    totalWinners: 0,
    totalUniqueWinners: 0,
    todayWinners: 0,
    totalCoupons: 0,
  });

  const [insightsLoading, setInsightsLoading] = useState(false);

  const rowsPerPage = 20;

  const prizeOptions = [
    { value: "Free delivery", label: "Free delivery" },
    { value: "Free mattress set with purchase", label: "Free mattress set with purchase" },
    { value: "$25 off", label: "$25 off" },
    { value: "$100 off", label: "$100 off" },
    { value: "$99.99 worth of Free accessories", label: "$99.99 worth of Free accessories " },
    { value: "Free 75 inch TV", label: "Free 75 inch TV" },
  ];

  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  // Build filters query params
  const buildFilterParams = () => {
    const params = new URLSearchParams();

    params.append("page", currentPage);
    params.append("limit", rowsPerPage);

    if (email.trim()) {
      params.append("email", email.trim());
    }

    if (couponCode.trim()) {
      params.append("coupon", couponCode.trim());
    }

    if (selectedPrize) {
      params.append("prize", selectedPrize);
    }

    if (dateRange?.length === 2) {
      params.append("startDate", dateRange[0].format("YYYY-MM-DD"));
      params.append("endDate", dateRange[1].format("YYYY-MM-DD"));
    }

    return params.toString();
  };

  // Winners table API
  const fetchTableData = async (page = 1, applyFilters = false) => {
    try {
      setLoading(true);

      let query = `page=${page}&limit=${rowsPerPage}`;

      if (applyFilters) {
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("limit", rowsPerPage);

        if (email.trim()) params.append("email", email.trim());
        if (couponCode.trim()) params.append("coupon", couponCode.trim());
        if (selectedPrize) params.append("prize", selectedPrize);

        if (dateRange?.length === 2) {
          params.append("startDate", dateRange[0].format("YYYY-MM-DD"));
          params.append("endDate", dateRange[1].format("YYYY-MM-DD"));
        }

        query = params.toString();
      }

      const response = await axios.get(`${Url}/api/v1/winners/get?${query}`);

      setData(response.data.data || []);
      setTotalPages(response.data.pagination?.totalPages || 1);
    } catch (error) {
      console.error("Failed to fetch table data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Insights API
  const fetchInsights = async () => {
    try {
      setInsightsLoading(true);

      const response = await axios.get(`${Url}/api/v1/winners/insights`);
      const stats = response.data?.data;

      setInsights({
        totalWinners: stats?.totalWinners || 0,
        totalUniqueWinners: stats?.totalUniqueWinners || 0,
        todayWinners: stats?.todayWinners || 0,
        totalCoupons: stats?.totalWinners || 0,
      });
    } catch (error) {
      console.error("Failed to fetch insights:", error);
    } finally {
      setInsightsLoading(false);
    }
  };

  useEffect(() => {
    fetchInsights();
  }, []);

  useEffect(() => {
    fetchTableData(currentPage, filtersApplied);
  }, [currentPage]);

  const handleFilters = async () => {
    try {
      setFilterLoading(true);
      setCurrentPage(1);
      setFiltersApplied(true);

      await fetchTableData(1, true);
    } finally {
      setFilterLoading(false);
    }
  };

  const handleResetFilters = async () => {
    setEmail("");
    setCouponCode("");
    setSelectedPrize("");
    setDateRange(null);
    setFiltersApplied(false);
    setCurrentPage(1);

    await fetchTableData(1, false);
  };

  const customStyles = {
    headCells: {
      style: {
        height: "52px",
        background: "transparent",
        textAlign: "center",
        justifyContent: "center",
        color: "var(--text-color-1)",
      },
    },
    cells: {
      style: {
        height: "66px",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "var(--standered-border)",
      },
    },
  };

  const columns = [
    {
      name: "Date",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          formatTimestamp(row.createdAt)
        ),
      width: "15%",
    },
    {
      name: "Email",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          row.email
        ),
      width: "25%",
    },
    {
      name: "Coupon Code",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          row.coupon || "-"
        ),
      width: "15%",
    },
    {
      name: "Prize",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          row.prize
        ),
      width: "45%",
    },
  ];

  const displayedData = loading ? Array(rowsPerPage).fill({}) : data;


  // Add new state
  const [exportLoading, setExportLoading] = useState(false);

  // CSV Export Function
  const handleExportCSV = async () => {
    try {
      setExportLoading(true);

      // Filters ke sath ALL data fetch karo
      const params = new URLSearchParams();
      params.append("page", 1);
      params.append("limit", 10000); // large limit

      if (email.trim()) {
        params.append("email", email.trim());
      }

      if (couponCode.trim()) {
        params.append("coupon", couponCode.trim());
      }

      if (selectedPrize) {
        params.append("prize", selectedPrize);
      }

      if (dateRange?.length === 2) {
        params.append("startDate", dateRange[0].format("YYYY-MM-DD"));
        params.append("endDate", dateRange[1].format("YYYY-MM-DD"));
      }

      const response = await axios.get(
        `${Url}/api/v1/winners/get?${params.toString()}`
      );

      const allData = response.data?.data || [];

      if (!allData.length) {
        alert("No data available to export!");
        return;
      }

      // CSV Headers
      const csvHeader = [
        "Date",
        "Email",
        "Coupon Code",
        "Prize",
      ];

      // CSV Rows
      const csvRows = allData.map((item) => [
        formatTimestamp(item.createdAt),
        item.email || "",
        item.coupon || "",
        item.prize || "",
      ]);

      // CSV content
      const csvContent = [
        csvHeader.join(","),
        ...csvRows.map((row) =>
          row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(",")
        ),
      ].join("\n");

      // Download file
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.setAttribute(
        "download",
        `Coupon_Winners_${dayjs().format("YYYY-MM-DD_HH-mm")}.csv`
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      alert("Failed to export CSV");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "15px", marginTop: "15px" }}>
      {/* Dashboard Tiles */}
      <div className="coupon_dashboard_tiles">
        <div className="coupon_dashboard_tile">
          <div className="cardTitle_cdt"><h2>Total</h2><p>Winners</p></div>
          <img src={couponicon} alt="" />
          <h3>{insightsLoading ? "..." : insights.totalWinners}</h3>
        </div>

        <div className="coupon_dashboard_tile">
          <div className="cardTitle_cdt"><h2>Total</h2><p>Unique Winners</p></div>
          <img src={couponicon} alt="" />
          <h3>{insightsLoading ? "..." : insights.totalUniqueWinners}</h3>
        </div>

        <div className="coupon_dashboard_tile">
          <div className="cardTitle_cdt"><h2>Today's</h2><p>Winners</p></div>
          <img src={couponicon} alt="" />
          <h3>{insightsLoading ? "..." : insights.todayWinners}</h3>
        </div>

        <div className="coupon_dashboard_tile">
          <div className="cardTitle_cdt"><h2>Total</h2><p>Coupons</p></div>
          <img src={couponicon} alt="" />
          <h3>{insightsLoading ? "..." : insights.totalCoupons}</h3>
        </div>
      </div>



      {/* Filters */}
      <div className="Filters-Section" style={{ width: "100%", "margin": "0px" }}>
        <Accordion allowZeroExpanded className="accordion">
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Filters</AccordionItemButton>
            </AccordionItemHeading>

            <AccordionItemPanel>
              <div className="filter-row-01">
                <div className="filter-label">Customer Email</div>
                <div className="filter-label">Coupon Code</div>
                <div className="filter-label">Date Range</div>
                <div className="filter-label">Prize</div>
              </div>

              <div className="filter-row-02">
                <InputField
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Email"
                />

                <InputField
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                  placeholder="Enter Coupon Code"
                />

                <RangePicker
                  format="YYYY-MM-DD"
                  value={dateRange}
                  onChange={(dates) => setDateRange(dates)}
                  style={{ width: "100%", height: "42px" }}
                  disabledDate={disabledDate}
                />

                <Dropdowncustom
                  options={prizeOptions}
                  selected={selectedPrize}
                  onChange={(value) => setSelectedPrize(value)}
                  dropdownClass="custom-dropdown-tax"
                  headerheight="40px"
                  dropdownstyle={{ width: "256px", height: "40px" }}
                />
              </div>

              <div className="filter-row-04">
                <CustomBtn
                  label="Reset"
                  withIcon
                  iconType="reset"
                  className="ResetBtn-OrderPage"
                  onClick={handleResetFilters}
                />

                <button
                  onClick={handleFilters}
                  className="apply_filter_btn"
                  disabled={filterLoading}
                >
                  {filterLoading ? "Loading..." : "Apply Filters"}
                </button>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>

      {/* Table */}
      <div className="coupons-addon">
        <div className="sectionall_1_a" style={{ "margin": 0, "width": "100%", "padding": "10px 20px 25px 20px" }}>

          <h2>SPIN & WIN Coupon Winners</h2>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              marginRight: "15px",
            }}
          >

            <CustomBtnLogo
              image={csv}
              label="Export CSV"
              withIcon={true}
              iconType="import"
              onClick={() => { handleExportCSV() }}
              type="button"
              style={{
                padding: "5px 10px"
              }}
            />

          </div>
        </div>

        <div className="table_coupons">
          <DataTable
            columns={columns}
            data={displayedData}
            customStyles={customStyles}
          />

          <ElipticalPagenation
            activePageIndex={currentPage}
            totalPages={totalPages}
            onPrevPage={() => currentPage > 1 && setCurrentPage((prev) => prev - 1)}
            onNextPage={() =>
              currentPage < totalPages && setCurrentPage((prev) => prev + 1)
            }
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
    </div>
  );
};

export default Coupons;